import useGrantedAuthScopes from '../useGrantedAuthScopes'

// Marks Modugen developers, granted via Auth0 RBAC like the other permission
// hooks. A pure frontend switch for work-in-progress UI -- unlike
// `access:admin`/`access:ai` no backend route reads it, so it must never be
// the only thing guarding data.
const DEV_SCOPE = 'access:dev'

interface DevUserState {
  isDevUser: boolean
  isLoading: boolean
}

const useIsDevUser = (): DevUserState => {
  const { grantedScopes, isLoading } = useGrantedAuthScopes()

  return {
    isDevUser: grantedScopes.includes(DEV_SCOPE),
    isLoading,
  }
}

export default useIsDevUser
